<template>
  <div @keyup.enter="enterSearch">
    <el-form :model="form" ref="form" class="table-search-bar" inline label-width="70px">
      <el-form-item label="状态" prop="status">
        <el-select v-model="form.status">
          <el-option v-for="item in statusOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="用户名" prop="username">
        <el-input v-model="form.username" placeholder="请输入用户名"></el-input>
      </el-form-item>
      <el-form-item label="客户名称" prop="customer">
        <el-input v-model="form.customer" placeholder="请输入客户名称"></el-input>
      </el-form-item>
      <el-form-item label="法人代表" prop="legalPerson">
        <el-input v-model="form.legalPerson" placeholder="请输入法人代表"></el-input>
      </el-form-item>
      <el-form-item label="审核时间" prop="auditTime">
        <el-date-picker
          v-model="form.auditTime"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :default-time="['00:00:00', '23:59:59']"
          value-format="yyyy-MM-dd HH:mm:ss">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleSearch" icon="el-icon-search">搜索</el-button>
        <el-button type="primary" @click="handleReset">重置</el-button>
      </el-form-item>
    </el-form>
    <el-table
      :data="list"
      tooltip-effect="light"
      style="width: 100%">
      <el-table-column
        prop="userName"
        label="用户名"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="mobile"
        label="注册手机"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="customerName"
        label="客户名称"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="corporateRepresentative"
        label="法人代表"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="mosaicAddress"
        label="公司所在地"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="orgName"
        label="认证经营组织"
        min-width="100"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        label="状态"
        :formatter="statusFormatter"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="auditTime"
        label="审核时间"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column label="操作" width="150">
        <template slot-scope="scope">
          <el-button
            size="mini"
            v-permission="'0031002'"
            @click="handleCheck(scope.$index, scope.row)">查看</el-button>
          <el-button
            size="mini"
            v-if="scope.row.status === 1"
            v-permission="'0031003'"
            @click="handleVerify(scope.$index, scope.row)">审核</el-button>
          </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10, 20 ,50, 100]"
      :page-size="listState.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="listState.total"
      :current-page="listState.pageNo"
      background>
    </el-pagination>
    <el-row class="export-row" type="flex" justify="end" v-permission="'0031004'">
      <el-col :span="4">
        每页
        <el-select class="width100" v-model="exportForm.pageSize" @change="handleExportSizeChange">
          <el-option v-for="item in sizeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        条
      </el-col>
      <el-col :span="4">
        第
        <el-select class="width100" v-model="exportForm.pageNo">
          <el-option v-for="item in pageOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        页
      </el-col>
      <el-col :span="3">
        <el-button type="primary" @click="handleExportCSV">导出报表</el-button>
      </el-col>
    </el-row>
    <check-dialog :show.sync="checkDialogShow" :info="checkDialogInfo"/>
    <verify-dialog :show.sync="verifyDialogShow" :info="verifyDialogInfo"/>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import CheckDialog from './checkDialog'
import VerifyDialog from './verifyDialog'
import { formatTime } from '../../../common/utils'

export default {
  name: 'CustomerArchivesApproval',
  components: { CheckDialog, VerifyDialog },
  data () {
    return {
      form: {
        status: '',
        username: '',
        customer: '',
        legalPerson: '',
        auditTime: [formatTime(new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1), true), formatTime(new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 23, 59, 59), true)]
      },
      exportForm: {
        pageSize: 1000,
        pageNo: 1
      },
      sizeOptions: [
        {
          label: '1000',
          value: 1000
        },
        {
          label: '5000',
          value: 5000
        },
        {
          label: '10000',
          value: 10000
        },
        {
          label: '20000',
          value: 20000
        }
      ],
      statusOptions: [
        {
          value: '',
          label: '全部'
        },
        {
          value: '1',
          label: '待审核'
        },
        {
          value: '2',
          label: '审核通过'
        },
        {
          value: '3',
          label: '审核未通过'
        }
      ],
      checkDialogShow: false,
      checkDialogInfo: {},
      verifyDialogShow: false,
      verifyDialogInfo: {}
    }
  },
  computed: {
    ...mapGetters({
      list: 'getCustomerArchivesApprovalList',
      listState: 'getCustomerArchivesApprovalListState'
    }),
    pageOptions () {
      const total = this.listState.total
      const size = this.exportForm.pageSize
      let totalPage = Math.floor(total / size)
      if (total % size) {
        totalPage++
      }
      const arr = []
      for (let index = 1; index <= totalPage; index++) {
        arr.push({
          label: index,
          value: index
        })
      }
      return arr
    }
  },
  mounted () {
    this.handleSearch()
  },
  methods: {
    ...mapActions(['getCustomerArchivesApprovalList', 'getCustomerArchivesApprovalDetail', 'exportCustomerArchivesApproval']),
    enterSearch (e) { // 回车搜索
      if (e.target.form && e.target.nodeName === 'INPUT') {
        this.handleSearch()
      }
    },
    handleSizeChange (val) {
      this.getCustomerArchivesApprovalList({ pageNo: 1, pageSize: val })
    },
    handleCurrentChange (val) {
      this.getCustomerArchivesApprovalList({ pageNo: val })
    },
    handleSearch () {
      const params = {
        ...this.form,
        auditTimeBegin: this.form.auditTime && this.form.auditTime.length > 0 ? this.form.auditTime[0] : '',
        auditTimeEnd: this.form.auditTime && this.form.auditTime.length > 1 ? this.form.auditTime[1] : '',
        pageNo: 1
      }
      delete params.auditTime
      this.getCustomerArchivesApprovalList(params)
    },
    // 导出每页条数变动监听
    handleExportSizeChange (val) {
      this.exportForm.pageNo = 1
    },
    handleExportCSV () {
      if (!Array.isArray(this.list) || this.list.length === 0) {
        this.$message({
          message: '暂无数据',
          type: 'warning'
        })
        return
      }
      this.$confirm('是否确认导出', '导出', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        const params = {
          ...this.form,
          auditTimeBegin: this.form.auditTime && this.form.auditTime.length > 0 ? this.form.auditTime[0] : '',
          auditTimeEnd: this.form.auditTime && this.form.auditTime.length > 1 ? this.form.auditTime[1] : '',
          ...this.exportForm
        }
        this.exportCustomerArchivesApproval(params).then((res) => {
          function createDownloadFile () {
            let blob = new Blob([res])
            let link = document.createElement('a')
            link.download = '档案审批.xls'
            link.style.display = 'none'
            link.target = '_Blank'
            link.href = window.URL.createObjectURL(blob)
            document.body.appendChild(link)
            link.click()
            window.URL.revokeObjectURL(link.href)
          }
          createDownloadFile()
          this.$message.success('导出成功')
        })
      }).catch(() => {})
    },
    handleReset () {
      this.$refs['form'].resetFields()
      this.form.auditTime = [formatTime(new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1), true), formatTime(new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 23, 59, 59), true)]
      this.handleSearch()
    },
    handleCheck (index, row) {
      this.getCustomerArchivesApprovalDetail({ id: row.id }).then(res => {
        // 打开查看界面
        this.checkDialogShow = true
        this.checkDialogInfo = Object.assign({}, res, {
          orgName: row.orgName
        })
      })
    },
    handleVerify (index, row) {
      this.getCustomerArchivesApprovalDetail({ id: row.id }).then(res => {
        // 打开审核界面
        this.verifyDialogShow = true
        this.verifyDialogInfo = Object.assign({}, res, {
          orgName: row.orgName
        })
      })
    },
    statusFormatter (row) {
      const status = this.statusOptions.find(item => item.value === row.status + '')
      return status.label
    }
  }
}
</script>
<style lang="scss" scoped>
.export-row {
  margin-top: 10px;
}
.width100{
  width: 100px;
}
</style>
